import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveMasterButton } from 'shared/common/slices/stickyPromoSlice';

/**
 * Хук для управления отображением стики-кнопок.
 * В один момент может быть видна только одна кнопка.
 * */
export const useFillApplicationStickyButtons = ({ landing }: { landing: 'seller' | 'buyer' }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const presentationBtn = document.querySelector(
      `[data-name=${landing === 'seller' ? 'HelpYouSell' : 'HelpYouBuy'}]`,
    ) as Element;

    if (!presentationBtn) {
      return;
    }

    const bottomButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            /**
             * Проверяем, что пользователь не находится в самом верху страницы
             * */
            if (window.scrollY !== 0) {
              dispatch(setActiveMasterButton(false));
            }
          } else {
            dispatch(setActiveMasterButton(true));
          }
        });
      },
      {
        threshold: 1,
        rootMargin: '0px',
      },
    );

    bottomButtonObserver.observe(presentationBtn);

    return () => {
      bottomButtonObserver.disconnect();
    };
  }, []);
};
